import React from 'react';
import "./style.css"

import html from ".//tech-logo/html.png"
import css from ".//tech-logo/css.png"
import js from ".//tech-logo/js.png"
import react from ".//tech-logo/react.png"
import express from ".//tech-logo/express.png"
import node from ".//tech-logo/node.png"
import mongodb from ".//tech-logo/mongodb.png"
import bootstrap from ".//tech-logo/bootstrap.png"
import ui from ".//tech-logo/ui.png"
import tailwind from ".//tech-logo/tailwind.png"
import git from ".//tech-logo/git.png"

export default function Dummy() {
    const skills = [
        { id: '1', title: 'HTML',img:html },
        { id: '2', title: 'CSS',img:css },
        { id: '3', title: 'JS',img:js },
        { id: '4', title: 'REACT',img:react },
        { id: '5', title: 'EXPRESS',img:express },
        { id: '6', title: 'NODE',img:node },
        { id: '7', title: 'MONGO',img:mongodb },
        { id: '8', title: 'BOOTSTRAP',img:bootstrap },
        { id: '9', title: 'MUI',img:ui },
        { id: '10', title: 'TAILWIND' ,img:tailwind},
        { id: '11', title: 'GIT' ,img:git}
    ];

    return (
        <section className="whole-card">
            {skills.map((item) => (
                <div key={item.id} className="card-skil-body">
                    <div className='card-skil-wrapper'>
                        <div className='skill-logo-name'>
                            <img className="fab fa-css3-alt css3 icon-tech" src={item.img}/>
                            <h2 className="skil-nam">{item.title}</h2>
                        </div>
                    </div>
                </div>
            ))}
        </section>
    );
}
